import React from "react";
import "./FloatingChatButton.css";
import { showIntercom } from "../../../utils/intercom";

const FloatingChatButton = () => {
  return (
    <button
      className="floating-chat-button"
      onClick={showIntercom}
      aria-label="Open Chat"
      title="Open Chat Support"
    >
      <svg width="24" height="24" viewBox="0 0 30 30" fill="none">
        <path d="M15 3.75C21.875 3.75 27.5 8.225 27.5 13.75C27.5 19.275 21.875 23.75 15 23.75C13.45 23.75 11.9625 23.525 10.5875 23.125C6.9375 26.25 2.5 26.25 2.5 26.25C5.4125 23.3375 5.875 21.375 5.9375 20.625C3.8125 18.8375 2.5 16.4125 2.5 13.75C2.5 8.225 8.125 3.75 15 3.75Z" fill="currentColor" />
      </svg>
    </button>
  );
};

export default FloatingChatButton;
